// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Nps$ReactHooksTemplate = require("./Nps.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var NpsLabel$ReactHooksTemplate = require("./NpsLabel.res.js");
var CustomerInfo$ReactHooksTemplate = require("./CustomerInfo.res.js");
var Substitution$ReactHooksTemplate = require("../common/Substitution.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var NpsRepresentationConfig$ReactHooksTemplate = require("./NpsRepresentationConfig.res.js");

function NpsRoundedBoxWithSmileyForm$NpsItem(props) {
  var onSelection = props.onSelection;
  var step = props.step;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: Curry._2(props.imageBasedOnIndex, step, props.imageClassName),
                      className: "small:h-6 h-12"
                    }),
                JsxRuntime.jsx("button", {
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx("span", {
                                  children: String(step)
                                }),
                            className: "p-1"
                          }),
                      className: props.className,
                      style: props.style,
                      onClick: (function ($$event) {
                          $$event.preventDefault();
                          Curry._1(onSelection, step);
                        })
                    })
              ],
              className: "flex flex-col gap-2 justify-between"
            });
}

var NpsItem = {
  make: NpsRoundedBoxWithSmileyForm$NpsItem
};

function colorBasedOnLikelyness(scale, index) {
  if (scale === "FiveScale") {
    switch (index) {
      case 0 :
      case 1 :
      case 2 :
      case 3 :
          return "#E60000";
      case 4 :
          return "#F79406";
      case 5 :
          return "#21AD04";
      default:
        return "#ffffff";
    }
  } else {
    switch (index) {
      case 0 :
      case 1 :
      case 2 :
      case 3 :
      case 4 :
      case 5 :
      case 6 :
          return "#E60000";
      case 7 :
      case 8 :
          return "#F79406";
      case 9 :
      case 10 :
          return "#21AD04";
      default:
        return "#ffffff";
    }
  }
}

function imageBasedOnIndex(scale, index, imageClassName) {
  if (scale === "FiveScale") {
    if (index !== 4) {
      if (index !== 5) {
        return JsxRuntime.jsx("img", {
                    className: imageClassName,
                    src: Image$ReactHooksTemplate.sadButton
                  });
      } else {
        return JsxRuntime.jsx("img", {
                    className: imageClassName,
                    src: Image$ReactHooksTemplate.happyButton
                  });
      }
    } else {
      return JsxRuntime.jsx("img", {
                  className: imageClassName,
                  src: Image$ReactHooksTemplate.neutralButton
                });
    }
  }
  if (index >= 9) {
    if (index < 11) {
      return JsxRuntime.jsx("img", {
                  className: imageClassName,
                  src: Image$ReactHooksTemplate.happyButton
                });
    }
    
  } else if (index >= 7) {
    return JsxRuntime.jsx("img", {
                className: imageClassName,
                src: Image$ReactHooksTemplate.neutralButton
              });
  }
  return JsxRuntime.jsx("img", {
              className: imageClassName,
              src: Image$ReactHooksTemplate.sadButton
            });
}

function normalizeConfiguration(config) {
  if (config === undefined) {
    return ;
  }
  var match = Js_json.decodeObject(config);
  if (match !== undefined) {
    return config;
  }
  var s = Js_json.decodeString(config);
  if (s === undefined) {
    return ;
  }
  try {
    var parsed = JSON.parse(s);
    var match$1 = Js_json.decodeObject(parsed);
    if (match$1 !== undefined) {
      return parsed;
    } else {
      return ;
    }
  }
  catch (exn){
    return ;
  }
}

function NpsRoundedBoxWithSmileyForm(props) {
  var substitutionVariables = props.substitutionVariables;
  var contentOnly = props.contentOnly;
  var overrideQuestionBlock = props.overrideQuestionBlock;
  var onChange = props.onChange;
  var language = props.language;
  var nps = props.nps;
  var scale = Nps$ReactHooksTemplate.scale(nps);
  var includeZero = Nps$ReactHooksTemplate.includeZero(nps);
  var configForCategories = normalizeConfiguration(props.configuration);
  var scaleString = NpsRepresentationConfig$ReactHooksTemplate.scaleStringFromNps(scale, includeZero);
  var categoryRanges = NpsRepresentationConfig$ReactHooksTemplate.getCategoryRangesFromConfig(configForCategories, scaleString);
  var categoryColors = NpsRepresentationConfig$ReactHooksTemplate.getCategoryColorsFromConfig(configForCategories);
  var colorForStep = function (v) {
    return NpsRepresentationConfig$ReactHooksTemplate.colorForStepValue(scaleString, v, categoryRanges, categoryColors);
  };
  var steps = function (count, offset) {
    return Belt_List.makeBy(count, (function (x) {
                  return x + offset | 0;
                }));
  };
  var scaleWiseClass;
  scaleWiseClass = scale === "FiveScale" ? "w-16 h-16 small:mt-6 mt-4 " + (
      includeZero ? "small:w-8 small:h-8" : "small:w-10 small:h-10"
    ) : "small:w-6 small:h-6 w-12 h-12";
  var normalCss = " " + scaleWiseClass + " focus:outline-none text-white small:text-xs text-xl\n    font-medium rounded ";
  var startRating = includeZero ? 0 : 1;
  var endRating;
  endRating = scale === "FiveScale" ? 5 : 10;
  var containerGap;
  containerGap = scale === "FiveScale" ? " small:gap-4 gap-6" : " small:gap-1 gap-2";
  var labelPadding;
  labelPadding = scale === "FiveScale" ? "lg:px-16" : "";
  var selectedCss = function (x) {
    if (Nps$ReactHooksTemplate.isAnswer(nps, x)) {
      return "text-blue-800 border-2 border-bleudefrance";
    } else {
      return "";
    }
  };
  var selectedImageCss = function (x) {
    if (Nps$ReactHooksTemplate.isAnswer(nps, x)) {
      return "block";
    } else {
      return "hidden";
    }
  };
  var rmName = CustomerInfo$ReactHooksTemplate.rmName(props.customerInfo);
  var questionText = Nps$ReactHooksTemplate.getTextTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)).replace("${RM_NAME}", rmName);
  var items = function (a, b) {
    var count = (b - a | 0) + 1 | 0;
    return $$Array.of_list(Belt_List.map(steps(count, a), (function (x) {
                      var partial_arg = Nps$ReactHooksTemplate.scale(nps);
                      return JsxRuntime.jsx(NpsRoundedBoxWithSmileyForm$NpsItem, {
                                  step: x,
                                  className: normalCss + (" " + selectedCss(x)),
                                  imageClassName: selectedImageCss(x),
                                  onSelection: (function (y) {
                                      Curry._1(onChange, Nps$ReactHooksTemplate.setAnswer(nps, y));
                                    }),
                                  style: {
                                    backgroundColor: colorForStep(x)
                                  },
                                  imageBasedOnIndex: (function (param, param$1) {
                                      return imageBasedOnIndex(partial_arg, param, param$1);
                                    })
                                }, String(x));
                    })));
  };
  var questionBlock;
  if (overrideQuestionBlock !== undefined) {
    questionBlock = Caml_option.valFromOption(overrideQuestionBlock);
  } else {
    var titleHtml = Substitution$ReactHooksTemplate.renderQuestionText(questionText, substitutionVariables);
    var descriptionHtml = Substitution$ReactHooksTemplate.renderQuestionText(Nps$ReactHooksTemplate.getDescriptionTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)), substitutionVariables);
    questionBlock = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
                  className: "survey-rich-text text-lg font-medium text-darkcharcoal py-6 whitespace-pre-line",
                  dangerouslySetInnerHTML: {
                    __html: titleHtml
                  }
                }),
            JsxRuntime.jsx("div", {
                  className: "survey-rich-text text-base font-normal text-darkcharcoal pb-8 whitespace-pre-line",
                  dangerouslySetInnerHTML: {
                    __html: descriptionHtml
                  }
                })
          ]
        });
  }
  var scaleBody = JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
                children: items(startRating, endRating),
                className: "flex w-full justify-center " + containerGap + " "
              }),
          JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("p", {
                              children: NpsLabel$ReactHooksTemplate.left(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)))
                            }),
                        className: "flex flex-col text-center text-red-600"
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("p", {
                              children: NpsLabel$ReactHooksTemplate.right(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)))
                            }),
                        className: "flex flex-col text-center text-green-600"
                      })
                ],
                className: " flex justify-between w-full pt-6 pb-10 text-spanishgray text-sm " + labelPadding + " "
              }),
          props.mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                  language: language
                }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
        ],
        className: "flex flex-col w-full"
      });
  if (contentOnly !== undefined && contentOnly) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                        children: items(startRating, endRating),
                        className: "flex w-full justify-center " + containerGap + " "
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx("p", {
                                      children: NpsLabel$ReactHooksTemplate.left(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)))
                                    }),
                                className: "flex flex-col text-center text-red-600"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx("p", {
                                      children: NpsLabel$ReactHooksTemplate.right(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)))
                                    }),
                                className: "flex flex-col text-center text-green-600"
                              })
                        ],
                        className: " flex justify-between w-full pt-6 pb-10 text-spanishgray text-sm " + labelPadding + " "
                      })
                ],
                className: "flex flex-col w-full"
              });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: questionBlock
                    }),
                scaleBody
              ],
              className: "w-full px-16 small:px-6 " + props.borderCss
            });
}

var make = NpsRoundedBoxWithSmileyForm;

exports.NpsItem = NpsItem;
exports.colorBasedOnLikelyness = colorBasedOnLikelyness;
exports.imageBasedOnIndex = imageBasedOnIndex;
exports.normalizeConfiguration = normalizeConfiguration;
exports.make = make;
/* react/jsx-runtime Not a pure module */
